export default [
  {
    type: 'input',
    model: 'name',
    clearable: true,
    title: 'Рекомендации'
  }
]
